export enum EstimateDetailTypeEnum {
  Normal = 1,
  ChangeOrder,
}

export enum EstimateStatusTypes {
  Draft,
  PendingReview,
  PendingSend,
  PendingApproval,
  Overdue,
  RevisionRequested,
  Rejected,
  Approved,
  CompletelyPaid,
  Unknown,
  ReviewRevisionRequested,
  Closed
}

/**
 * Statuses where the client has already accepted, so the document must show its approval date and
 * must never be called expired. Mirrors the same constant in ProjulV1Portal's estimate.enum.ts.
 */
export const ESTIMATE_NO_LONGER_A_LIVE_OFFER_STATUSES: EstimateStatusTypes[] = [
  EstimateStatusTypes.Approved,
  EstimateStatusTypes.CompletelyPaid,
  EstimateStatusTypes.Closed
];

export function isEstimateNoLongerALiveOffer(status: EstimateStatusTypes | null | undefined): boolean {
  return status != null && ESTIMATE_NO_LONGER_A_LIVE_OFFER_STATUSES.indexOf(status) !== -1;
}

export enum CostLineTypes {
  Unknown,
  Labor, // In use
  MaterialInventory,
  Material, //MaterialNonInventory in V1  // In use
  Note,
  Discount,
  Rebate,
  Other, // In use
}


export enum TagModalTypeEnum {
  customerList = 'customerList',
  tags = 'tags',
  leadSource = 'leadSource',
  projectType = 'projectType',
  leadProjectType = 'leadProjectType',
  project = 'project',
  OnHoldReason = 'OnHoldReason',
  task = 'task',
  tax = 'tax',
  estimateSectionName = 'estimateSectionName',
  costline = 'costline',
  laborCategory = 'laborCategory',
  materialCategory = 'materialCategory',
  trade = 'trade',
  InvoiceCostLine = 'invoiceCostLine'
}

export enum TagTypes {
  Unknown = 0,
  Labor,
  Materials,
  WorkerGroup,
  Project,
  OnHoldReason,
  EstimateSectionName
}


export enum TypeOfCalculationEnum {
  Section = 1,
  Total,
}

export enum EstimateDetailSectionCostlineTypeEnum {
  Section = 1,
  Costline
}

export enum EstimateAcceptedRejectedRevisionBy {
  Company = 1,
  Customer
}

export enum EstimateSelectionTypeEnum {
  RequiredSingleSelection = 1,
  OptionalSingleSelection = 2,
  OptionalMultipleSelection = 3
}
export const MarkupEnumType = {
  Percentage: '%',
  Amount: '$'
}

export enum DetailsToIncludeEnum {
  Published,
  UnPublished,
  Approved,
  Projected,
  All
}